export const searchInText = (text: string, searchString: string): boolean =>
  text?.toLowerCase()?.includes(searchString?.toLowerCase())
